import * as ActionPartnerTypes from 'actions/partner';

const defaultState = [];

export default function accountPlayers(state = defaultState, action) {
  switch (action.type) {
    case ActionPartnerTypes.ACCOUNT_PLAYERS_RECEIVE:
      return action.payload.accountPlayers;
    default:
      return state;
  }
}
